import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";

import { toast } from "react-toastify";

import { format } from "date-fns";

import {
  // FaEdit,
  FaCalendarAlt,
  FaAngleRight
} from "react-icons/fa";

import { handleDialog, formatMoney, formatedDate } from "~/scripts/index.js";

import pt from "date-fns/locale/pt";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import NavigationButtons from "~/components/NavigationButtons";

import api from "~/services/api";

import Title from "~/components/Title";

import {
  // New,
  ModalDateBaixa,
  Scroll,
  ChequeSelected
} from "./styles";

export default function CardBook() {
  const accesses = useSelector(state => state.auth.newaccesses);
  const profile = useSelector(state => state.user.profile);
  const filial = useSelector(state => state.filial);
  const [checkBook, setCheckBook] = useState([]);
  const [block, setBlock] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [checkBaixar, setCheckBaixar] = useState({});
  const [selected, setSelected] = useState(new Date());

  const [filtro, setFiltro] = useState({
    date: format(new Date(), "yyyy-MM-dd"),
    option: "all"
  });

  const { date, option } = filtro;

  useEffect(() => {
    async function getCheques() {
      const response = await api.get(`card/show/${filial.filial}?page=${page}`);

      const { data } = response;
      // console.log(data)
      setCheckBook(data.cards);
      setPages(data.pages);
      setBlock(false);
    }

    getCheques();
  }, [block, option, date, filial, page]);

  function baixar(date) {
    setSelected(date);
  }

  function handleOpenDate() {
    setOpenDate(!openDate);
  }

  function handleData({ date }) {
    setFiltro({
      ...filtro,
      date: format(new Date(date), "yyyy-MM-dd")
    });
    setOpenDate(!openDate);
  }

  async function handleBaixar() {
    try {
      await api.delete(
        `/baixa_checks/${checkBaixar.id}/${profile.id}/${selected}`
      );
      setBlock(true);
      setOpenModal(false);
      toast.success(`Baixa realizada com sucesso!`, { className: "success" });
    } catch (err) {
      toast.error(`Falha ao realizar baixa`, { className: "error" });
    }
  }

  function handleShowModal(id, correntista, approved_at, number, value, pre) {
    setCheckBaixar({ id, correntista, approved_at, number, value, pre });

    setOpenModal(true);
  }

  async function handleFiltroSelect(e) {
    if (e === "all") {
      setFiltro({
        date: format(new Date(), "yyyy-MM-dd"),
        option: e
      });
    } else {
      setFiltro({ ...filtro, option: e });
    }
  }

  return (
    <>
      <div className="gradeFiltros">
        <p>Filtros:</p>
        {/* <FiltroData
          openDate={openDate}
          handleOpenDate={handleOpenDate}
          selected={parseISO(date)}
          handleData={handleData}
        /> */}
        {/* <FiltroSelect
          options={[
            { id: "all", title: "Todos" },
            { id: "withLow", title: "Baixados" },
            { id: "withoutDischarge", title: "Não baixados" }
          ]}
          handleFiltroSelect={handleFiltroSelect}
        /> */}
      </div>
      <table className="gradeTable">
        <thead className="gradeHeader">
          <tr>
            <td>Id</td>
            <td>Data de Emissão</td>
            <td>Data de Pagamento</td>
            <td>Lançamento de Dízimo</td>
            <td>Payment ID</td>
            <td>Valor</td>
            <td>P.D.V.</td>
            <td>Operadora</td>
            <td>Banco</td>
            <td>Conciliado</td>
          </tr>
        </thead>
        <tbody className="gradeBody">
          {checkBook && checkBook.length > 0 ? (
            checkBook.map((crd, index) => {
              return (
                <tr
                  key={crd.id}
                  id={crd.id}
                  className={`checkBook ${
                    crd.conciliation_id
                      ? "concialized"
                      : crd.cards.dizimo.approved_at
                      ? " approved "
                      : null
                  }`}
                  onClick={() => handleDialog(crd, "checkBook")}
                >
                  <td>{crd.id}</td>
                  <td>{formatedDate(crd.date)}</td>
                  <td>{formatedDate(crd.due_date)}</td>
                  <td>{crd.cards.dizimo.id}</td>
                  <td>{crd.payment_id}</td>
                  <td>
                    {filial.country.currency}{" "}
                    {formatMoney(crd.value.toFixed(2), filial.country.language)}
                  </td>
                  <td>{crd.cards.pos.name}</td>
                  <td>{crd.cards.pos.operator.name}</td>
                  <td>{crd.cards.pos.operator.bank.name}</td>
                  <td>{crd.conciliation_id ? "Sim" : "Não"}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7}>Não há cartões.</td>
            </tr>
          )}
        </tbody>
      </table>
      <NavigationButtons setPage={setPage} page={page} pages={pages} />

      {openModal && (
        <Scroll>
          <div className="overlay"></div>
          <ModalDateBaixa>
            <header>
              <Title
                back={true}
                func={() => setOpenModal(false)}
                title={"Cancelar"}
              />
            </header>
            <div className="container">
              <h1>Baixar cheque</h1>
              <div className="form">
                <div className="rowInputs">
                  <label htmlFor="date">
                    <div>
                      <FaCalendarAlt size={20} />
                      <br />
                      Data
                    </div>
                    <DatePicker
                      style={{ border: "none" }}
                      selected={selected}
                      dateFormat={
                        profile.language === "pt-BR"
                          ? "dd/MM/yyyy"
                          : "MM/dd/yyyy"
                      }
                      minDate={new Date(filial.open_date)}
                      onChange={date => baixar(date)}
                      locale={pt}
                    />
                  </label>
                  <button
                    type="submit"
                    className="btnFinish"
                    onClick={() => handleBaixar()}
                  >
                    Finalizar
                    <FaAngleRight size={20} />
                  </button>
                </div>
              </div>
              <ChequeSelected>
                <li>
                  <table>
                    <thead>
                      <tr>
                        <td>Data de Baixa</td>
                        <td>N° Cheque</td>
                        <td>Valor</td>
                        <td>Pré</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{format(new Date(selected), "dd/MM/yyy")}</td>
                        <td>{checkBaixar.number}</td>
                        <td>
                          {formatMoney(
                            checkBaixar.value.toFixed(2),
                            filial.country.language
                          )}
                        </td>
                        <td>{checkBaixar.pre}</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ChequeSelected>
            </div>
          </ModalDateBaixa>
        </Scroll>
      )}
    </>
  );
}
